import { render, staticRenderFns } from "./PisCofins.vue?vue&type=template&id=5d4a6f85&scoped=true&"
import script from "./PisCofins.vue?vue&type=script&lang=js&"
export * from "./PisCofins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a6f85",
  null
  
)

export default component.exports